<template>
  <div class="container tablecon" style="width: 1280px;">
    <div class="two" id="yuanshu1" :class="{'gudingo':guding}" v-for="(item,index9) in Title" :key="index9+9">
      <div class="T_title1">{{item.til1}}</div>
      <div class="T_title2">{{item.til2}}</div>
      <div class="T_title3">{{item.til3}}</div>
      <div class="T_title4">{{item.til4}}</div>
      <div class="T_title5">{{item.til5}}</div>
      <div class="T_title6">{{item.til6}}</div>
      <div class="T_title7">{{item.til7}}</div>
      <div class="T_title8">{{item.til8}}</div>
    </div>
    <div class="three" id="yuanshu2">
      <div class="three_for" v-for="(college,index) in list">
        <div class="Cont Cont1">
          <div class="Cont_img">
            <img style="width: 100%;height: 100%;" :src="($resourcesUrl+'/college/'+`${college.collegeId}`+'/'+`${college.collegeIcon}`)" width="110px"
              height="110px">
          </div>
          <div class="Cont_Nr">
            <p  @click="xueshengjianjie(0,college)">{{college.collegeName}}</p>
            <div class="Cont_Card" v-if="college.collegeLevel!=null&&college.collegeLevel!=''">
              <span v-for="(list,index12) in college.collegeLevel.split(',')">{{list}}</span>
            </div>
            <div class="Cont_Card" v-if="college.college!=null">
              <icollege :item="college"></icollege>
            </div>
          </div>
        </div>
        <div class="Cont Cont2">
          <p>{{college.collegeRank}}</p>
        </div>
        <div class="Cont Cont3">
          <p>{{AREA_OBJ[college.collegeArea]}}</p>
        </div>
        <div class="Cont Cont4">
          <p>{{college.collegeSubject}}</p>
        </div>
        <div class="Cont Cont5">
          <p>{{college.collegeNature == 1?'公立':'民办'}}</p>

        </div>
        <div class="Cont Cont6">
          <p>{{college.collegeSubjection}}</p>
        </div>
        <div class="Cont Cont7">
          <p>{{college.collegeEducational}}</p>
        </div>
        <div class="Cont Cont8">
          <div class="Cont8_Le">
            <div class="Cont8_Le1" @click="xueshengjianjie(4,college)">院校分数线</div>
            <div class="Cont8_Le2" @click="toluqulv(college)">测试录取率</div>
          </div>
          <div class="Cont8_Ri">
            <p @click="xueshengjianjie(0,college)">院校简介</p>
            <p @click="xueshengjianjie(3,college)">招生简章</p>
            <p @click="xueshengjianjie(4,college)">录取数据</p>
          </div>
          <div class="Cont8_dw" @click="shou(college.collegeId)">
            <img src="../../../src/assets/img/tuceng9.png" v-if="userCang.indexOf(college.collegeId)!=-1">
            <img src="../../../src/assets/img/tuceng8.png" v-else>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import icollege from '../../components/icollege.vue'
  export default {
    props: {
      list: {
        type: Array
      },
      guding: {
        type: Boolean
      },
      userCang:{
        type: Array
      },

    },
    components: {
      icollege,
    },
    data() {
      return {
        // 标题
        Title: [{
          til1: '院校名称',
          til2: '排名',
          til3: '地区',
          til4: '类型',
          til5: '性质',
          til6: '隶属',
          til7: '学历层次',
          til8: '操作',
        }],
        AREA_OBJ: this.$utils.getlocalStorage('AREA_OBJ'),
      };
    },
    mounted() {
      window.addEventListener('scroll', this.handleScrollx, true)
    },
    methods: {
      shou(id){
        this.$emit("shou",id)
      },
      // 操作
      xueshengjianjie(obg,college) {
        if(obg == 4){
          if (this.$utils.tologin(this)) {
            if (this.$utils.getUserInfo(this)) {
              if (this.$utils.getFenshu(this)) {
                this.$utils.setlocalStorage("collegeInfo", college);
                // this.$router.push('/xyzy_jianjie?num='+obg)
                let routeUrl = this.$router.resolve({
                     path: "/xyzy_jianjie",
                     query: {num:obg,id:college.collegeId}
                   });
                 window.open(routeUrl.href,'_blank')
              }
            }
          }
        } else {
          this.$utils.setlocalStorage("collegeInfo", college);
          // this.$router.push('/xyzy_jianjie?num='+obg)
          let routeUrl = this.$router.resolve({
               path: "/xyzy_jianjie",
               query: {num:obg,id:college.collegeId}
             });
           window.open(routeUrl.href,'_blank')
        }

      },
      toluqulv(college){
        if (this.$utils.tologin(this)) {
          if (this.$utils.getUserInfo(this)) {
            if (this.$utils.getFenshu(this)) {
              this.$router.push('/cegailv?collegeName='+college.collegeName)
            }
          }

        }

      },
    },

  }
</script>

<style scoped="scoped">
.gudingo {
    position: fixed;
    top: 70px;
    left: ;
    transform: translate(0);
    margin-top: 0 !important;
    width: 1280px !important;
    z-index: 9;
  }

  .gudingo div {
    flex-shrink: 0;
  }
  /* 内容标题 */
  .two {
    display: flex;
    width: 100%;
    height: 50px;
    background-color: #F66464;
    margin-top: 20px;
    border-radius: 5px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 50px;
    color: #FFFFFF;
  }

  .two .T_title1 {
    width: 380px;
    text-align: center;
  }

  .two .T_title2 {
    width: 90px;
    text-align: center;
  }

  .two .T_title3 {
    width: 90px;
    text-align: center;
  }

  .two .T_title4 {
    width: 90px;
    text-align: center;
  }

  .two .T_title5 {
    width: 90px;
    text-align: center;
  }

  .two .T_title6 {
    width: 117px;
    text-align: center;
  }

  .two .T_title7 {
    width: 150px;
    text-align: center;
  }

  .two .T_title8 {
    flex: 1;
    text-align: center;
  }

  /* 中间内容 */
  .three {
    width: 100%;
    height: auto;
    margin-top: 11px;
    min-height: 440px;
    margin-bottom: 55px;
  }

  .three .three_for {
    display: flex;
    width: 100%;
    height: 135px;
    /* border: 1px solid #EBE9E9;
    border-radius: 10px;
    margin-top: 11px; */
    border: 1px solid #c0c4cc;
    border-radius: 10px;
    margin-top: 18px;
  }

  .three .Cont1 {
    width: 380px;
    height: 100%;
    display: flex;
    align-items: center;
    padding-top: 0px;
    padding-left: 15px;
    box-sizing: border-box;
  }

  .three .Cont {
    border-right: 1px solid #EBE9E9;
  }

  .three .Cont2 {
    width: 90px;
    height: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 32px;
  }

  .three .Cont3 {
    width: 90px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    line-height: 32px;
  }

  .three .Cont4 {
    width: 90px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    line-height: 32px;
  }

  .three .Cont5 {
    width: 90px;
    height: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 32px;
  }

  .three .Cont6 {
    width: 117px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    line-height: 32px;
  }

  .three .Cont7 {
    width: 150px;
    height: 100%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 32px;
  }

  .three .Cont8 {
    flex: 1;
    height: 100%;
    border: none;
    padding: 15px 20px;
    box-sizing: border-box;
    display: flex;
    position: relative;
  }

  .Cont_img {
    width: 90px;
    height: 90px;
  }

  .Cont_Nr {
    margin-left: 20px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 135px;
  }

  .Cont_Nr p {
    font-size: 20px;
    font-family: MicrosoftYaHei;
    line-height: 20px;
    color: #29A7E1;
  }

  .Cont_Card {
    margin-top: 10px;
  }

  .Cont_Card span {
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 7px;
    color: #333333;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #E8E8E8;
    padding: 5px;
    margin-right: 5px;
    margin-top: 0px;
    display: inline-block;
    word-wrap: break-word;
    overflow: hidden;
    white-space: pre-wrap;
  }

  .three_for .Cont2 p {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #F41325;
  }

  .three_for .Cont3 p,
  .three_for .Cont4 p,
  .three_for .Cont5 p,
  .three_for .Cont6 p,
  .three_for .Cont7 p {
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: #333333;
  }

  .Cont8_Le {
    display: flex;
    flex-direction: column;
  }

  .Cont8_Le .Cont8_Le1 {
    width: 100px;
    height: 34px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #29A7E1;
    opacity: 1;
    text-align: center;
    line-height: 34px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
    cursor: pointer;
  }

  .Cont8_Le .Cont8_Le2 {
    width: 100px;
    height: 34px;
    background: #F41325;
    border: 1px solid #F41325;
    opacity: 1;
    text-align: center;
    line-height: 34px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    margin-top: 28px;
    cursor: pointer;
  }

  .Cont8_Ri {
    height: 95px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-left: 30px;
  }

  .Cont8_Ri p {
    cursor: pointer;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 20px;
    color: #666666;
  }

  .Cont8_dw {
    width: 32px;
    height: 37px;
    position: absolute;
    top: 0px;
    right: 19px;
  }

  .Cont8_dw img {
    width: 32px;
    height: 37px;
  }
</style>



// WEBPACK FOOTER //
// src/views/information/collegelist.vue